import { render, staticRenderFns } from "./noveltyinfo.vue?vue&type=template&id=4231d513&"
import script from "./noveltyinfo.vue?vue&type=script&lang=js&"
export * from "./noveltyinfo.vue?vue&type=script&lang=js&"
import style0 from "./noveltyinfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports